import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/confluence': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M2.3 412.2c42.3-66.9 125.2-233.2 373.1-112.6 39.7 19.1 83.7 39.9 105.9 50.3 8 3.7 11.7 13.2 8.1 21.3l-50.4 114.1c-0.1 0.1-0.1 0.3-0.2 0.4-3.9 8.1-13.6 11.6-21.7 7.7-200.4-95.2-213.8-111.5-280.9 0.7 0 0-0.1 0.1-0.1 0.2-4.7 7.7-14.7 10-22.4 5.3l-105.9-65.2c-7.6-4.7-10-14.6-5.5-22.2zM509.7 100.1c-42.6 67.5-125.4 232.9-373.4 112.9-39.7-19.2-83.8-40-106-50.4-8-3.7-11.7-13.2-8.1-21.3l50.5-114.1c0.1-0.1 0.1-0.3 0.2-0.4 3.9-8.1 13.6-11.6 21.7-7.7 199.5 94.7 213.3 111.7 280.6-0.9 0.2-0.4 0.4-0.7 0.6-1 5-7.5 15.1-9.4 22.6-4.4l105.8 65.1c7.6 4.7 10 14.6 5.5 22.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/confluence.js
// module id = 759
// module chunks = 0